import EventsExecutor from './EventsExecutor';
import Action from './Action';
import createContext from './createContext';
import { parseActions } from './parser';
import getContext from '../apiUpgrade/getContext';

export default class ActionEngine {
  static create(pageId, apis) {
    this.pageId = pageId;
    return new ActionEngine(apis);
  }

  constructor(apis) {
    this.actionsMap = {};
    this.builtinActions = {};
    this.apis = apis;
  }

  createEventsExecutor(xprops, stateDaemons) {
    return new EventsExecutor(this, xprops, stateDaemons);
  }

  addAction(action) {
    this.actionsMap[action.id] = new Action(action);
  }

  parseActions(actions) {
    return parseActions(actions);
  }

  addActions(actions) {
    this.parseActions(actions).forEach(this.addAction, this);
  }

  setActions(actions) {
    this.actionsMap = {};
    this.addActions(actions);
  }

  setBuiltinActions(actions) {
    this.parseActions(actions).forEach((action) => {
      this.builtinActions[action.id] = new Action(action);
    });
  }

  getAction(id) {
    return this.actionsMap[id] || this.builtinActions[id];
  }

  addAPIs(apis) {
    this.apis = {
      ...this.apis,
      ...apis,
    };
  }

  createContextForDataPool(dataPool) {
    return {
      ...this.apis,
      get dp() {
        return dataPool;
      },
      getDataPool() {
        return dataPool;
      },
    };
  }

  createAPIContext(xprops, params) {
    return createContext({
      ...this.apis,
      params,
    }, xprops);
  }

  setContext(context) {
    this.context = context;
  }

  /**
   * 获取全局内置的 context
   */
  getContext() {
    return this.context;
  }

  /**
   * 全局绑定在 action 上的 context
   */
  getActionContext() {
    if (this.actionContext) {
      return this.actionContext;
    }
    // 创建一个
    this.actionContext = getContext(this.getContext());
    return this.actionContext;
  }
}
